import { ItemType } from '../misc/item-type.enum';
import { UserBuilder } from '../users/user-builder';
import { ActivityEventType } from './activity-event-type.enum';
var ActivityEventBuilder = /** @class */ (function () {
    function ActivityEventBuilder() {
        this.activityEvent = {
            id: 'b0b',
            itemType: ItemType.TICKET,
            itemId: 'b0b2',
            eventType: ActivityEventType.TICKET_LABELS_UPDATED,
            infoValues: {},
            user: new UserBuilder().build(),
            creationDate: Date.now()
        };
    }
    ActivityEventBuilder.prototype.withId = function (id) {
        this.activityEvent.id = id;
        return this;
    };
    ActivityEventBuilder.prototype.withItemId = function (itemId) {
        this.activityEvent.itemId = itemId;
        return this;
    };
    ActivityEventBuilder.prototype.withItemType = function (itemType) {
        this.activityEvent.itemType = itemType;
        return this;
    };
    ActivityEventBuilder.prototype.withEventType = function (eventType) {
        this.activityEvent.eventType = eventType;
        return this;
    };
    ActivityEventBuilder.prototype.withUser = function (user) {
        this.activityEvent.user = user;
        return this;
    };
    ActivityEventBuilder.prototype.withCreationDate = function (creationDate) {
        this.activityEvent.creationDate = creationDate;
        return this;
    };
    ActivityEventBuilder.prototype.withInfoValues = function (infoValues) {
        this.activityEvent.infoValues = infoValues;
        return this;
    };
    ActivityEventBuilder.prototype.build = function () {
        return this.activityEvent;
    };
    return ActivityEventBuilder;
}());
export { ActivityEventBuilder };
//# sourceMappingURL=activity-event.builder.js.map